// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  statusIcon: {
    marginTop: 30,
    width: 80,
    height: 80,
  },
  text: {
    width: '65%',
    marginTop: 35,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GREY,
    textAlign: 'center',
    [theme.breakpoints.down(520)]: {
      width: '75%',
    },
  },
  button: {
    marginTop: 30,
    width: 200,
  },
});

export default styles;
